<template>

  <rpm-table
      title="Categorias de serviços"
      :columns="columns"
      :data="sourceServiceCategories"
      :loading="tableDataIsLoading"
      :pagination="pagination"
      @change-page="getSourceServiceCategories"
  >TE
    <template #functions>
      <section class="flex flex-row-reverse w-full">
        <rpm-button
            class="w-6 h-6 rounded"
            font-size="text-sm"
            icon="fa-solid fa-plus"
            @click="openModal({})"
        ></rpm-button>
      </section>
    </template>

    <template #actions="{ item }">
      <rpm-button
        icon="fa-solid fa-pen-to-square"
        color="transparent"
        tooltip-text="editar"
        @click="openModal(item)"
      ></rpm-button>

      <rpm-button
        v-if="item.enabled"

        icon="fa-solid fa-eye-slash"
        color="transparent"
        tooltip-text="desativar"
        @click="item.enabled = false"
      ></rpm-button>

      <rpm-button
        v-else

        icon="fa-solid fa-eye"
        color="transparent"
        tooltip-text="ativar"
        @click="item.enabled = true"
      ></rpm-button>
    </template>
  </rpm-table>

  <rpm-modal
    :header="this.sourceServiceCategoryForm.id ? 'Atualizar Categoria de Serviço':'Criar Categoria de Serviço'"
    class="flex flex-col gap-y-8"
    persist
    :open="modalOpen"
    @close="modalOpen = false"
  >
    <section class="flex flex-col gap-6">

      <rpm-input
          v-model="sourceServiceCategoryForm.name"
          label="Nome"
          required
          placeholder="Nome do serviço"
      ></rpm-input>

      <section class="grid grid-cols-3">

        <rpm-input
            type="switch"
            class="items-center"
            v-model="sourceServiceCategoryForm.visible_web"
            label="Portal"
        ></rpm-input>

        <rpm-input
            type="switch"
            class="items-center"
            v-model="sourceServiceCategoryForm.visible_admin"
            label="Atendimento"
        ></rpm-input>

        <rpm-input
            type="switch"
            class="items-center"
            v-model="sourceServiceCategoryForm.visible_mobile"
            label="Aplicativo"
        ></rpm-input>

      </section>

      <rpm-input
          v-model="sourceServiceCategoryForm.description"
          label="Descrição"
          required
          placeholder="Descrição"
      ></rpm-input>

      <rpm-input
          v-model="sourceServiceCategoryForm.icon"
          label="Ícone"
          optional
          placeholder="Ícone"
      ></rpm-input>

      <rpm-input
          v-model="sourceServiceCategoryForm.parent_source_service_category_id"
          label="Categoria superior"
          type="select"
          optional
          :options="allSourceServiceCategories"
          optionLabel="name"
          optionValue="id"
      ></rpm-input>

    </section>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="modalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          @click="save"
      ></rpm-button>
    </section>
  </rpm-modal>

</template>


<script>

import Badge from "#components/Badge.vue";
import RpmTable from "#components/RpmTable.vue";
import RpmModal from "#components/RpmModal.vue";
import {request} from "#repositories/repository";
import sourceServiceCategory from "#repositories/sourceServiceCategoryRepository";
import {getErrors} from "#functions/validator";

export default {
  name: "SourceServiceCategory",
  components: {
    RpmTable,
    RpmModal,
    Badge
  },
  data() {
    return {
      columns: [
        {field: "name", label: "Nome"},
        {field: "parent", label: "Categoria pai"},
        {field: "description", label: "Descrição", class: "text-truncate"},
        {field: "enabled", label: "Habilitado"},
        {field: "is_public", label: "Público"},
      ],
      modalOpen: false,
      tableDataIsLoading: true,
      sourceServiceCategoryForm: {},
      sourceServiceCategories: [],
      allSourceServiceCategories: [],
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 15,
        last_page: 0,
        links: []
      }
    };
  },
  methods: {
    async getSourceServiceCategories(page = 0) {
      if (page && page !== 0) this.pagination.page = page;

      this.tableDataIsLoading = true;

      this.sourceServiceCategories = request.pagination(
          await sourceServiceCategory.getSourceServiceCategories(this.pagination),
          this.pagination
      );

      this.tableDataIsLoading = false;
    },
    async fetchAllSourceServiceCategories() {
      this.allSourceServiceCategories = (await sourceServiceCategory.getSourceServiceCategories()).data
    },
    openModal(item) {
      this.modalOpen = true;
      this.sourceServiceCategoryForm = item;
    },
    async save() {
      if(this.sourceServiceCategoryForm.id){
        sourceServiceCategory.updateSourceServiceCategory(this.sourceServiceCategoryForm.id, this.sourceServiceCategoryForm).then((response) => {
          this.$notify('Categoria de serviço modificado com sucesso', 'success');
          this.getSourceServiceCategories();
          this.modalOpen = false;
        }).catch((response) => {
          this.$notify('Erro ao modificar o categoria serviço', 'error');
          getErrors(this.errors, response.errors);
        });
      }else{
        this.sourceServiceCategoryForm.enabled = true;
        sourceServiceCategory.storeSourceServiceCategory(this.sourceServiceCategoryForm).then(() => {
          this.$notify('Categoria de serviço criada com sucesso', 'success');
          this.getSourceServiceCategories();
          this.modalOpen = false;
        }).catch((response) => {
          this.$notify('Erro ao criar o categoria serviço', 'error');
          getErrors(this.errors, response.errors);
        });
      }
    }
  },
  mounted() {
    this.getSourceServiceCategories();
    this.fetchAllSourceServiceCategories()
  },
};
</script>
